import React from 'react';
import { withRouter } from 'react-router-dom';
import ForgotPasswordForm from '../components/sections/ForgotPasswordForm';
import { TokenService } from '../api/tokenService';

class ForgotPassword extends React.Component {
  componentDidMount() {
    let token = null;

    if (TokenService && typeof TokenService.getLocalAccessToken === 'function') {
      token = TokenService.getLocalAccessToken();
    } else {
      token = localStorage.getItem('accessToken'); // fallback
    }

    if (token) {
      // already logged in → go to dashboard (or "/" if you prefer)
      this.props.history.replace('/');
    }
  }

  render() {
    return (
      <ForgotPasswordForm className="illustration-section-01" />
    );
  }
}

export default withRouter(ForgotPassword);
